import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { Address, CartLine, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { useCallback } from 'react';
import { useDatalayerService } from './useDatalayerService';

interface UseTrackPlaceOrderParams {
    request: IRequestContext;
    telemetry: ITelemetry;
    cartLines: CartLine[] | undefined;
    products: SimpleProduct[] | undefined;
    totalAmount: number | undefined;
    cartId: string | undefined;
    guestEmail: string | undefined;
    shippingAddress: Address | undefined;
    billingAddress: Address | undefined;
}

export const useTrackPlaceOrder = ({
    request,
    telemetry,
    cartLines,
    products,
    totalAmount,
    cartId,
    guestEmail,
    shippingAddress,
    billingAddress
}: UseTrackPlaceOrderParams): (() => void) => {
    const datalayerService = useDatalayerService({ request, telemetry });

    return useCallback((): void => {
        if (cartId && datalayerService.hasCheckoutEventFired(cartId, 'add_payment_info')) {
            return;
        }
        if (cartId) {
            datalayerService.markCheckoutEventFired(cartId, 'add_payment_info');
        }
        datalayerService.pushCheckoutStepIdentity(guestEmail, shippingAddress, billingAddress);
        datalayerService.pushCheckoutStep('add_payment_info', cartLines ?? [], products ?? [], totalAmount);
    }, [datalayerService, cartId, guestEmail, shippingAddress, billingAddress, cartLines, products, totalAmount]);
};
